import StateFilteredAddress from '../../forms/address/StateFilteredAddress';
import { StateFilterData } from '../../forms/address/types';
import FormHandler from '../../forms/FormHandler';
import AnalyticsService from '../../analytics/AnalyticsService';
import { IViewItemAnalytics } from '../../analytics/types';
import fireAddToCartAnalytics from '../../analytics/fireAddToCartAnalytics';

interface PageConfig {
  stateFilterData: StateFilterData;
  viewItemAnalytics: IViewItemAnalytics;
}

window.tnew.page.initialize = ({ stateFilterData, viewItemAnalytics }: PageConfig) => {
  if (viewItemAnalytics) {
    AnalyticsService.trackViewItem(viewItemAnalytics);
    AnalyticsService.pushEcommerceItems(viewItemAnalytics.items);
  }

  const $form = document.querySelector('#tn-gift-certificate-form') as HTMLFormElement;

  const formHandler = new FormHandler($form, {
    onValidationSuccess: () => {
      const amountInput = $form.querySelector('#AddGiftCertificate_Amount') as HTMLInputElement;
      const amount = parseFloat(amountInput?.value) || 0;

      fireAddToCartAnalytics(viewItemAnalytics, [
        { price: amount, quantity: 1, itemVariant: '' },
      ]);

      $form.submit();
    },
  });

  StateFilteredAddress.createForCustomFormFields($form, formHandler, stateFilterData);
};
